import { NgModule } from '@angular/core';

import { DateTimeService } from './date-time.service';

@NgModule({
  providers: [
    DateTimeService
  ]
})
export class DateTimeServiceModule { }